import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import IabCategoriesFilterResult from "../../components/filters/IabCategoriesFilter/IabCategoriesFilterResult";
import IabCategoriesFilterView from "../../components/filters/IabCategoriesFilter/IabCategoriesFilterView";
import type { IAppsFilterOptionsDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import IabCategoriesFilter from "./IabCategoriesFilter";

const createIabCategoriesFilter = (description: IAppsFilterOptionsDto): SearchFilterInstance => ({
    key: "iabCategories",
    trackingName: "App IAB Categories",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.iab-categories.title" },
    tooltipText: { key: "si.find_apps.filters.iab-categories.tooltip" },
    filter: new IabCategoriesFilter({
        options: description.iabCategories,
    }),
    filterView: IabCategoriesFilterView,
    filterResultView: IabCategoriesFilterResult,
});

export default createIabCategoriesFilter;
